import { gql, useMutation } from '@apollo/client'

export const getMutation = (type: string, commandMeta: EntityCommandMeta) =>
  useMutation(gql(gqlMutationString(type, commandMeta)))

export const gqlMutationString = (type: string, commandMeta: EntityCommandMeta) => `
  mutation Execute${type}Command(${commandMeta.PARAMS}) {
    executeCommand(input: { ${commandMeta.INPUT} }) {
      ${commandMeta.OUTPUT}
    }
  }`
